"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useTranslation } from "~/components/translate";
import SwedenFlag from "~/shadcn/icons/logo-sweden";
import UKFlag from "~/shadcn/icons/loog-united-kingdom";
import { Button } from "~/shadcn/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "~/shadcn/ui/dropdown-menu";

// ----------------------------------------------------------------------

export const allLangs = [{
  label: "Svenska",
  value: "sv",
  icon: <SwedenFlag size="28px" />
}, {
  label: "English",
  value: "en",
  icon: <UKFlag size="28px" />
}];
export default function LanguagePopover() {
  const $ = _c(15);
  const {
    setLocale,
    lang
  } = useTranslation();
  let t0;
  if ($[0] !== lang) {
    t0 = allLangs.find(langObj => langObj.value === lang);
    $[0] = lang;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentLang = t0;
  let t1;
  if ($[2] !== setLocale) {
    t1 = langValue => {
      setLocale(langValue as AppLocale);
    };
    $[2] = setLocale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleChangeLang = t1;
  if (!currentLang) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Button variant="ghost" size="icon" className="text-muted-foreground rounded-full opacity-0"><div className="w-[28px] h-[28px]" /></Button>;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== currentLang.icon) {
    t2 = <DropdownMenuTrigger id="nav-language-trigger" asChild={true}><Button variant="ghost" size="icon" className="text-muted-foreground rounded-full">{currentLang.icon}</Button></DropdownMenuTrigger>;
    $[5] = currentLang.icon;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== currentLang.value || $[8] !== handleChangeLang) {
    t3 = allLangs.map(option => <DropdownMenuItem key={option.value} onClick={() => handleChangeLang(option.value)} className={option.value === currentLang.value ? "bg-gray-200 dark:bg-gray-700" : ""}>{option.icon}<span className="ml-2">{option.label}</span></DropdownMenuItem>);
    $[7] = currentLang.value;
    $[8] = handleChangeLang;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <DropdownMenuContent align="end" className="w-40">{t3}</DropdownMenuContent>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <DropdownMenu>{t2}{t4}</DropdownMenu>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}